<template lang="pug">
    article.news-item
        BlockVisibilityTrigger(:theme='"black"')

        .news-item__wrap
            .news-item__content
                .news-item__photo
                    img(:src='getImage(news.photoCover || news.photofeature)', :alt='news.title')
                .news-item__description
                    h1.h1.news-item__title(v-html="news.title")
                    span.news-item__lead(v-html="news.lead")
                    .news-item__text(v-html='news.text')

                    ShareNews(
                        :id='news.id'
                        :title='news.title'
                        :description='news.lead',
                        :img='getImage(news.photofeature)'
                        )

            router-link.news-item__btn(
                to='/news',
                v-html='data.all')

        Footer

</template>

<script>
import newsData from '../assets/data/news.json';
import Footer from '../components/Footer.vue';
import BlockVisibilityTrigger from '../components/BlockVisibilityTrigger.vue';

export default {
    name: 'News',

    components: {
        Footer,
        BlockVisibilityTrigger,
        ShareNews: () => import('@/components/ShareNews.vue')
    },

    props: {
        id: String
    },

    data() {
        return {
            data: newsData
        };
    },

    computed: {
        news() {
            return this.data.list.find(el => el.id === this.id);
        }
    },

    created() {
        // if (this.data.list.find(el => el.id === this.id).hidden) {
        //     this.$router.push('/news');
        // }
    },

    methods: {
        addNews() {
            this.countItemsInSet += this.setSize;
        },

        getImage(path) {
            try {
                return require(`@/assets/img/news/${path}`);
            } catch (e) {
                return require(`@/assets/img/news/nophoto.jpg`);
            }
        }
    }
};
</script>

<style lang="scss">
@import '../assets/css/vars.scss';
@import '../assets/css/base.scss';
@import '~poly-fluid-sizing';

.news-item {
    padding-top: 8em;

    @media (--viewport-tablet) {
        padding-top: 5em;
    }

    &__wrap {
        width: calc(var(--layout-column-width) * 8 + var(--layout-gutter-width) * 7);
        // width: 100%;
        margin: 0 auto;
        // margin: 0 7.8em;
        padding-bottom: 11.2em;

        @media (--viewport-tablet) {
            width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
            padding-bottom: 5em;
        }

        @media (--viewport-mobile-pt) {
            width: calc(var(--layout-column-width) * 11 + var(--layout-gutter-width) * 12.4);
            padding-bottom: 5em;
        }
    }

    &__lead {
        font-family: var(--font-main);
        font-weight: 400;
        font-size: 28px;
        line-height: 1.5;
        color: var(--color-main-text);

        $mapFontSize: (
            375px: 20px,
            1440px: 28px,
            // 1920px: 37px
        );
        @include poly-fluid-sizing('font-size', $mapFontSize);

        // @media (--viewport-tablet) {
        //     text-transform: none;
        // }

        &--color-main {
            color: var(--color-main-text);
        }
    }

    &__title.h1,
    &__lead,
    h2,
    h3 {
        text-align: center;
        color: var(--color-main-text);
        // width: calc(var(--layout-column-width) * 7.55 + var(--layout-gutter-width) * 6);
        width: calc(var(--layout-column-width) * 7 + var(--layout-gutter-width) * 6);
        max-width: 43.2rem;
        margin: 0 auto;
        color: black;
        padding: 0 5.65rem;
        margin-bottom: 2.22rem;

        @media (--viewport-tablet) {
            width: 100%;
            padding: 0;
        }

        @media (--viewport-mobile-pt) {
            padding: 0 calc(var(--layout-column-width) * 0.33 + var(--layout-gutter-width));
        }
    }

    h2 {
        text-align: left;
        font-size: 1.67em;
        font-weight: 600;
        line-height: 1.21;
        margin-top: 5.55rem;
        margin-bottom: 2.22rem;
        color: black;

        @media (--viewport-tablet) {
            font-size: 1.44rem;
        }

        @media (--viewport-mobile-pt) {
            font-size: 1.33rem;
        }
    }

    h3 {
        text-align: left;
        font-size: 1.3em;
        font-weight: 600;
        line-height: 1.21;
        margin-top: 4.5rem;
        margin-bottom: 2rem;
        color: black;

        @media (--viewport-tablet) {
            font-size: 1.3rem;
        }

        @media (--viewport-mobile-pt) {
            font-size: 1.2rem;
        }
    }

    &__title {
        margin-bottom: 2.22rem;

        @media (--viewport-mobile-pt) {
            margin-bottom: 1.33rem;
        }
    }

    &__lead {
        display: block;
        margin-bottom: 1.5rem;

        @media (--viewport-mobile-pt) {
            margin-bottom: 2.2rem;
        }
    }

    &__content {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-bottom: 4em;
    }

    &__photo {
        position: relative;
        max-height: 80vh;

        img {
            width: 100%;
            object-fit: cover;
        }
    }

    &__description {
        position: relative;
        // font-size: 0.6em;
        flex-grow: 1;
        padding-top: 4.44rem;
        background-color: var(--color-main-bg);

        @media (--viewport-tablet) {
            // font-size: 1em;
            padding: 1.5em calc(var(--layout-column-width) + var(--layout-gutter-width)) 2.3em;
        }

        @media (--viewport-mobile-pt) {
            // font-size: 1em;
            padding: 0;
            padding-top: 1.8em;
        }
    }

    &__date {
        font-weight: 350;
        text-align: center;
        margin-bottom: 4em;

        @media (--viewport-tablet) {
            position: absolute;
            top: -1.5em;
            left: 0;
            font-size: 1em;
            text-align: left;
            padding: 0.3em calc(var(--layout-column-width) + var(--layout-gutter-width));
            margin-bottom: 1em;
            background-color: var(--color-main-bg);
        }
    }

    &__name {
        font-family: var(--font-accent);
        text-transform: uppercase;
        margin-bottom: 4em;
        text-align: center;

        @media (--viewport-tablet) {
            text-align: left;
            margin-bottom: 1em;
        }
    }

    &__text {
        width: calc(var(--layout-column-width) * 7 + var(--layout-gutter-width) * 6);
        max-width: 43.2rem;
        // width: calc(47.61rem - 5.65rem);
        margin: 0 auto;
        // column-count: 2;
        // column-gap: var(--layout-gutter-width);

        @media (--viewport-tablet) {
            font-size: 1em;
            width: 100%;
            column-count: 1;
            margin-bottom: 2em;
        }

        ul {
            list-style: disc;
            margin-left: 1rem;

            &.reset {
                list-style: none;
            }

            li {
                margin-bottom: 1.11em;
                padding-left: 1em;

                @media (--viewport-mobile-pt) {
                    padding-left: 0;
                }

                &::marker {
                    color: currentColor;
                }
            }
        }
        ol {
            margin-left: 1rem;

            li {
                margin-bottom: 1.11em;
                padding-left: 1em;

                @media (--viewport-mobile-pt) {
                    padding-left: 0.5rem;
                }

                ul {
                    padding: 0;
                    margin-bottom: 0;
                    li {
                        list-style: disc;
                        margin-bottom: initial;
                        margin-top: 0.17rem;
                    }
                }
            }
        }

        b,
        strong {
            font-weight: 600;
        }

        blockquote,
        p,
        ul,
        ol {
            margin-bottom: 1.5rem;
            padding: 0 5.65rem;

            @media (--viewport-tablet) {
                padding: 0;
            }

            @media (--viewport-mobile-pt) {
                padding: 0 calc(var(--layout-column-width) * 0.33 + var(--layout-gutter-width));
            }
        }

        blockquote p,
        blockquote ul,
        blockquote ol {
            padding: 0;
        }

        table {
            width: 50%;
            margin: 0 auto;
            margin-bottom: 2.22rem;
        }

        ol li {
            list-style-type: inherit;
        }

        em {
            font-style: italic;
        }

        footer {
            &.reference {
                font-size: 0.67em;
                margin-top: 5.55rem;
                margin-bottom: 2.22rem;

                h2 {
                    font-size: 1em;
                    font-weight: 600;
                    text-transform: uppercase;
                    margin-top: 2.22rem;
                    margin-bottom: 0.5rem;
                }
            }
        }
    }

    &__btn {
        display: table;
        color: var(--color-accent-text);
        font-family: var(--font-accent);
        text-transform: uppercase;
        text-decoration: none;
        padding: 0.5em 0.5em 0.3em;
        border: 4px solid var(--color-main-bg);
        margin: 0 auto;

        &:hover,
        &:focus {
            color: var(--color-main-text);
            background-color: var(--color-main-bg);
            border: 4px solid transparent;
        }
    }

    figure {
        width: 100%;
        text-align: center;
        // margin-top: 5.55rem;
        img {
            width: 100%;
            display: inline;
            margin-bottom: 1.11rem;
        }
        margin-bottom: 2.22rem;

        figcaption {
            // display: block;
            font-weight: 600;
            margin-top: 5.55rem;
            font-size: 1rem;
            color: var(--color-main-text);
            margin-bottom: 2.22rem;
            padding: 0 5.65rem;

            @media (--viewport-tablet-pt) {
                padding: 0;
            }

            @media (--viewport-mobile-pt) {
                padding: 0 calc(var(--layout-column-width) * 0.33 + var(--layout-gutter-width));
            }
        }

        p {
            margin: 0;
            font-size: 0.67em;
            color: var(--color-img-description);
        }

        &.quote {
            text-align: left;

            figcaption {
                font-size: 1em;
                font-weight: inherit;
                margin: 0 0 0.5em;
            }

            blockquote {
                p {
                    font-size: 1em;
                    color: inherit;
                }
            }
        }
    }
}
</style>
